import React, { useEffect, useState, useRef } from 'react';
import Icon from 'screens/shared/icon';
import Dialog from 'screens/shared/dialog';
import { useNotification } from 'screens/shared/hooks/notifications';
import { Paper, Collapse } from '@mui/material';
import { _t, getDeviceType, isEmptyObject } from 'utils';
import { DEVICE_TYPE, RESOURCE_TYPE } from 'constant';
import { getConfig } from 'utils/config';
import assets from 'themes/base/assets';
import { form } from 'types';
import Form from './form';

export default ({
  title = '',
  type = RESOURCE_TYPE.SERVER,
  children,
  isAdd = true,
  onAdd = null,
  showAddForm = false,
  isFilter = true,
  filterRender = null,
  addRender = null,
  addAction = null,
  onSaved = null,
  isToggleButton = false,
  isEmpty = false,
  emptyMsg = _t('No Data'),
  style = {},
  isTopbar = true,
  className = '',
  refresh,
  onCloseAddForm,
  scrollIntoForm,
  customTopbarForm,
}) => {
  const elementRef = useRef(null);
  const [openWindows, setOpenWindows] = useState({
    add: showAddForm,
    filter: false,
  });
  const [toggleItems, setToggleItems] = useState(true);
  const [actionFormItem, setActionFormItem] = useState(false);

  const actions = Array.isArray(addAction) ? addAction : [addAction];
  const [, successes] = useNotification({ actions });

  const setOpenWindow = (value) => {
    if (onCloseAddForm && value.add === false) {
      onCloseAddForm();
    } else if (scrollIntoForm && value.add === true && elementRef?.current) {
      setTimeout(() => {
        elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
    setOpenWindows({
      add: false,
      filter: false,
      ...value,
    });
  };

  useEffect(() => {
    if (successes.length && openWindows.add) {
      setOpenWindow({ add: false });
      setToggleItems(true);
      if (onSaved) {
        onSaved();
      }
    }
    // eslint-disable-next-line
  }, [successes]);

  useEffect(() => {
    if (openWindows.add !== showAddForm) {
      setOpenWindows({ ...openWindows, add: showAddForm });
    }
    // eslint-disable-next-line
  }, [showAddForm]);

  const renderFormDialog = () => {
    const localActionForm = customTopbarForm.formProps(actionFormItem);
    return (
      <Dialog
        show
        title={customTopbarForm?.title}
        titleClassName="-m-b-12- -p-b-1"
        content={(
          <Form
            {...form({
              ...localActionForm,
              onSubmit: (e) => {
                setActionFormItem({});
                if (localActionForm.onSubmit) localActionForm.onSubmit(e, actionFormItem);
              },
              onCancel: () => setActionFormItem({}),
            })}
          />
        )}
        isCloseButton={false}
        closeHandler={() => setActionFormItem({})}
        style={{ minWidth: 300 }}
      />
    );
  };

  const onFilterClick = () => {
    setOpenWindow({ filter: !openWindows.filter });
  };

  const onAddClick = () => (onAdd ? onAdd() : setOpenWindow({ add: !openWindows.add }));

  const { features = {} } = getConfig();
  return (
    <div ref={elementRef} className={`cards cards-${type} ${className}`} style={style}>
      {isTopbar && (
        <div className="cards-top">
          {(!!title || !!isAdd || !!isFilter) && (
            <h3 className="cards-top-title">
              {!!isToggleButton && !isEmpty ? (
                <span style={{ padding: 7 }} onClick={() => setToggleItems(!toggleItems)}>
                  <Icon
                    name={`chevron-${toggleItems ? 'down' : 'right'}`}
                    style={{
                      position: 'relative', top: -1, marginRight: -2, fontSize: 14,
                    }}
                  />
                  <span className="text">{title}</span>
                </span>
              )
                : (
                  title ? <span className="text">{title}</span> : ''
                )}

              {!!isAdd && (
                <span className="circle-button cards-icon" onClick={onAddClick}>
                  <Icon name="plus" />
                  {_t('Add')}
                </span>
              )}

              {!!isFilter && !isEmpty && !!toggleItems && (
                <span className="circle-button cards-icon" onClick={onFilterClick}>
                  <Icon name="filter" />
                  {_t('Filter')}
                </span>
              )}

              {!!refresh && (
                <span className="circle-button cards-icon" onClick={refresh}>
                  <Icon name="sync-alt" style={{ marginRight: '0px' }} />
                </span>
              )}

              {
                customTopbarForm && (
                  <span className="circle-button cards-icon" onClick={() => setActionFormItem({ time: true })}>
                    {customTopbarForm?.title}
                  </span>
                )
              }
            </h3>
          )}
        </div>
      )}

      {!!filterRender && !!toggleItems && (
        <Collapse in={openWindows.filter} collapsedSize="0px">
          <Paper style={{ marginTop: 20 }}>
            {filterRender}
          </Paper>
        </Collapse>
      )}

      {!!addRender && (
        <Collapse in={openWindows.add} collapsedSize="0px">
          <Paper style={{ marginTop: 20 }}>
            {openWindows.add && (
              getDeviceType() === DEVICE_TYPE.DESKTOP && features.formDialog ? (
                <Dialog
                  show
                  content={addRender}
                  isCloseButton
                  closeHandler={() => setOpenWindow({ add: false })}
                  style={{ minWidth: 500 }}
                />
              ) : (
                addRender
              )

            )}
          </Paper>
        </Collapse>
      )}

      {isEmpty && !openWindows.add && (
        <div
          className="empty"
          style={{
            marginTop: 15,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={assets.EMPTY} alt="Empty" style={{ width: 80, opacity: 0.8 }} />
          <h3 style={{ color: 'lightgray', fontSize: 'var(--font-size-highlighted-text)' }}>{emptyMsg}</h3>
        </div>
      )}

      <Collapse in={toggleItems} collapsedSize="0px">
        <div className="cards-items">
          {children}
        </div>
      </Collapse>

      {!isEmptyObject(actionFormItem) && renderFormDialog()}
    </div>
  );
};
